import { render, staticRenderFns } from "./newHead_light.vue?vue&type=template&id=323dbe36&scoped=true"
import script from "./newHead_light.vue?vue&type=script&lang=js"
export * from "./newHead_light.vue?vue&type=script&lang=js"
import style0 from "./newHead_light.vue?vue&type=style&index=0&id=323dbe36&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "323dbe36",
  null
  
)

export default component.exports